/**
 * @file http.service.ts
 * @module to make http request
 * @author Nagendra
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocalstorageService } from '../localstorage/localstorage.service';
import { timeout, catchError } from 'rxjs/operators';

@Injectable()
export class HttpService {

  constructor(private http: HttpClient, private localservice: LocalstorageService, public router: Router) { }
  public baseUrl: string = environment.baseUrl + '';

  public redirectTo(moduleName: string, route?: string): void {
    let routeArray = [moduleName];
    if (route) {
      routeArray.push(route);
    }
    this.router.navigate(routeArray);
  };
  /**function to respond for post call */
  public httpPost(option: any, isAuthRequired: boolean): Observable<any> {
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    if (isAuthRequired){
      httpAuthOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': this.localservice.getData('token')
        })
      };
    }
    option.url = this.baseUrl + option.url;
    console.log('option.body', option.body);
    console.log(option.url);
    console.log(this.localservice.getData('token'));

    return this.http.post(option.url, option.body, httpAuthOptions);
  }

  /**function to respond for put call */
  public httpPut(option: any): Observable<{}> {
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': this.localservice.getData('token')
      })
    };

    option.url = this.baseUrl + option.url;
    return this.http.put(option.url, option.body, httpAuthOptions)
  }

  /**function to respond for get call and return required data*/
  public httpGet(option: any): Observable<any> {
    console.log("httpGet");
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization':  this.localservice.getData('token')
      })
    };
    option.url = this.baseUrl + option.url;
    return this.http.get(option.url, httpAuthOptions).pipe(
      timeout(10000),
      catchError(e => {
        // do something on a timeout
        return null;
      })
    );
  }

  // public httpGet1(option: any): Observable<any> {
  //   console.log("httpGet");
    
  //   var httpAuthOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       'Authorization':  this.localservice.getData('token')
  //     })
  //   };
  //   option.url = this.baseUrl + option.url;
  //   console.log("Url is ",option.url);
    
  //   return this.http.get(option.url, httpAuthOptions);
  // }

  public httpDelete(option: any): Observable<{}> {
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': this.localservice.getData('token')
      })
    };

    option.url = this.baseUrl + option.url;
    return this.http.delete(option.url,  httpAuthOptions);
  }
  cardsService(){
    return this.http.get('../../../');
  }

  loggedIn() {
    return !!localStorage.getItem('token');
  }
//    keyEmailCorrection(data):any{
//   //   return this.http.get("https://cccampdash.incubation.bridgelabz.com/campaign/dashboard/user/portal/register/mcq?emailId="+emailID)
//   var httpAuthOptions = {
//   headers: new HttpHeaders({
//     'Content-Type': 'application/json',
//     'Authorization':  'eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiREVWIiwiZXhwIjoxNTcwODgyOTQwLCJ1c2VySWQiOiIgIn0.4_ItJZA_2GM-zxnL8JkRNL8RYEdWgdQkudSP3tP_D_U'
//   })};
//   return this.http.post("http://192.168.0.230:8080/et/mcq/users/updateuserkey",data,httpAuthOptions);
   
// }
  // registration(data,shortName){
  //   return this.http.post("https://cccampdash.incubation.bridgelabz.com/campaign/dashboard/user/register/mcq/"+shortName,data);
  // }
  cityUpdate(data):Observable<any>{
    console.log('city data --->',data[0]);
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.localservice.getData('token')
      })
    };
    return this.http.post("http://192.168.0.167:8080/et/mcq/users/updaterecord",data,httpAuthOptions);
  }
}
